import * as React from 'react';
import {WithI18nProps, withI18n} from '@shopify/react-i18n';
import {Flex, Badge, Button, Currency, Link, Tags, Text, NOOP} from 'components/UIKit';
import * as locales from '../../locales';
import {ListingMetrics} from '../ListingMetrics';
import {ListingMetric, ListingShop} from '../../types';
import styles from './ListingHeader.scss';

export interface ListingHeaderProps {
  shop: ListingShop;
  metrics: ListingMetric[];
  onDomainClick?: React.MouseEventHandler;
  onContactClick?: React.MouseEventHandler;
}

function ListingHeaderComponent({
  i18n,
  shop,
  metrics,
  onDomainClick = NOOP,
  onContactClick = NOOP,
}: ListingHeaderProps & WithI18nProps) {
  const showMetrics = !shop.starterShop;
  const showSoldBadge = shop.sold;
  const showPriceAndContact = !shop.sold;

  return (
    <section className={styles.Container}>
      <Flex className={styles.Top} alignItems="flex-start" justifyContent="space-between">
        <div>
          {showSoldBadge && (
            <Flex className={styles.BadgeWrap}>
              <Badge text={i18n.translate('sold')} type="lightGrey" className={styles.Badge} />
            </Flex>
          )}
          <Text type="h2" text={shop.title} className={styles.Title} component="h1" />
          {shop.isPrivate ? (
            <Text text={i18n.translate('urlHidden')} />
          ) : (
            <Link
              rel="nofollow"
              resetMargin={false}
              className={styles.Domain}
              onClick={onDomainClick}
              text={shop.shopDomain}
              newTab
            />
          )}
          <Tags tags={shop.shortTags} className={styles.Tags} />
        </div>
        {showPriceAndContact && (
          <Flex className={styles.Contact} direction="column" alignItems="flex-end">
            <Currency
              emphasis
              display="bigger"
              value={shop.salePrice}
              style={{marginBottom: '16px', textAlign: 'right'}}
            />
            <Button label={i18n.translate('contactSeller')} onClick={onContactClick} />
          </Flex>
        )}
      </Flex>
      {showMetrics && <ListingMetrics hideWarnings metrics={metrics} className={styles.Metrics} />}
    </section>
  );
}

export const ListingHeader = withI18n({
  fallback: locales.en,
  id: 'Listing',
})(ListingHeaderComponent);

export default ListingHeader;
